(ns teamoesterreich.user-mode.prevent.prevent-personal
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.firebase.fb-questionnaire-helper :as fb-q-helper]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.ui-helper.stars :as stars]
    ))





(defn get-card []
  (let [
        !publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)

        selected-questionnaire-cs (r/cursor store/app-state [:state :selected-questionnaire])
        questionnaires-cs (r/cursor store/app-state [:questionnaires])
        person-questionnaires (into {} (filter (fn [[uuid q]] (and (:appearance-self q)
                                                                   (:active q)
                                                                   (if show-unpublished? true (:published q))
                                                                   ))
                                               @questionnaires-cs))]

    [mui/card {:style {:padding "12px 0 5px 0"}}
     [mui/typography {:variant "h5"} "Persönliche Vorbereitung"]
     (stars/five-stars (fb-q-helper/get-personal-stars))
     [mui/list {:component "nav" :aria-label "personal questionnaires" :style {:margin "0 10px 0 10px"}}
      (for [[uuid q] person-questionnaires]
        (let [onClick-fn (fn []
                           (reset! selected-questionnaire-cs uuid)
                           (a/set-page :questionnaire-intro))]
          ;(log/out "qq " (clj->js q))
          ^{:key (str "person-questionnaires-" uuid)} [mui/list-item {:key     (str "questionnaire" (:name q))
                                                                      :button  true
                                                                      :onClick onClick-fn}
                                                       [mui/list-item-text {:primary (str (:name q) (when-not (:published q) " - [unveröffentlicht]"))}]
                                                       [mui/list-item-secondary-action
                                                        {:edge "end" :aria-label "goto" :onClick onClick-fn}
                                                        [mui/icon-button [keyboard-arrow-right]]]
                                                       ]
          ))
      ]
     ]))


